import * as FC from "@fluentui/react-components";

export const DeleteButton = ({
    buttonText = "删除",
    confirm = "确认删除",
    onClick,
}) => {
    return (
        <FC.Popover withArrow>
            <FC.PopoverTrigger>
                <FC.Button>{buttonText}</FC.Button>
            </FC.PopoverTrigger>
            <FC.PopoverSurface>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: 10,
                    }}
                >
                    <FC.Button onClick={onClick} appearance="primary">
                        {confirm}
                    </FC.Button>
                </div>
            </FC.PopoverSurface>
        </FC.Popover>
    );
};
